"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startConnectivityContext = startConnectivityContext;
const browser_core_1 = require("@datadog/browser-core");
function startConnectivityContext(hooks) {
    hooks.register(0 /* HookNames.Assemble */, ({ eventType }) => ({
        type: eventType,
        connectivity: (0, browser_core_1.getConnectivity)(),
    }));
}
//# sourceMappingURL=connectivityContext.js.map